module.exports = __webpack_public_path__ + "static/media/history_huy.a370e2fb.png";